import React, {useEffect, useState} from "react";
import {useWelcomeStyle} from '../styles/WelcomeStyle';
import {CircularProgress, Typography} from "@material-ui/core";
import AppColors from "../colors/AppColors";
import {RootStateOrAny, useDispatch, useSelector} from "react-redux";
import {LoginState} from '../enums/AuthState';
import {Constants} from '../constants/Constants';
import {Link, Redirect} from "react-router-dom";
import Routes from "../constants/Routes";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import clsx from "clsx";
import LoginEmailView from "../views/LoginEmailView";
import LoginPasswordView from "../views/LoginPasswordView";
import Button from "@material-ui/core/Button";
import Strings from "../lang/Strings";
import {Validator} from "../utils/Validator";
import MaterialSnackBar from "../views/MaterialSnackBar";
import axios from "axios";
import EndPoints from "../net/EndPoints";
import UsersManager from "../managers/UsersManager";

export default function MiniAuthView() {

    const classes = useWelcomeStyle();
    const loginState: LoginState = useSelector((state: RootStateOrAny) => state.appReducer[Constants.LOGIN_STATE]);

    const logInEmail = useSelector((state: RootStateOrAny) => state.appReducer[Constants.AUTH_EMAIL]);
    const loginPassword = useSelector((state: RootStateOrAny) => state.appReducer[Constants.AUTH_PASSWORD]);

    const [openSnack, setOpenSnack] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [snackSeverity, setSnackSeverity] = useState("warning");
    const rememberMe: boolean = useSelector((state: RootStateOrAny) => state.appReducer[Constants.REMEMBER_ME]);
    const [loggedIn, setLoggedIn] = useState(false);

    const [navigateToSignUp, setNavigateToSignUp] = useState(false);

    const loginStarted = loginState === LoginState.STARTED;

    const handleSnackClose = () => {
        setOpenSnack(false);
    }

    const dispatch = useDispatch();

    const handleRememberMeChange = (event: any) => {
        dispatch({
            type: Constants.LOGIN_STATE_REMEMBRANCE,
            payload: {
                [Constants.REMEMBER_ME]: event.target.checked
            }
        });
    };

    const snackError = (message: string) => {
        setSnackMessage(message);
        setSnackSeverity("error");
        setOpenSnack(true);
    }

    const dispatchLogInState = (newLoginState: LoginState) => {
        dispatch({type: Constants.LOGIN_STATE_CHANGED, payload: {[Constants.LOGIN_STATE]: newLoginState}});
    }

    const loginUser = () => {
        if (Validator.isEmailValid(logInEmail as string)) {
            let loginData = {
                email: logInEmail as string,
                password: loginPassword as string,
            }
            // noinspection DuplicatedCode
            axios.post(EndPoints.LOGIN, loginData).then(data => {
                let userData = data["data"]["data"];
                userData[Constants.REMEMBER_ME] = rememberMe;
                UsersManager.saveLoggedInUser(JSON.stringify(userData));
                dispatch({
                    type: Constants.LOGGED_IN_USER_DATA_CHANGED,
                    payload: JSON.stringify(userData)
                });
                dispatchLogInState(LoginState.IDLE);
                setLoggedIn(true);
            }).catch(error => {
                let errorResponseData = error.response["data"]
                let message = errorResponseData["message"] ?? "Error completing log in. Please try again";
                dispatchLogInState(LoginState.IDLE);
                snackError(message);
            });
        } else {
            dispatchLogInState(LoginState.IDLE);
            snackError("Invalid Email address provided");
        }
    }

    useEffect(() => {
        if (loginStarted) {
            loginUser();
        }
    }, [loginStarted]);

    const initLogin = () => {
        if (logInEmail && loginPassword) {
            if (Validator.isEmailValid(logInEmail as string)) {
                dispatchLogInState(LoginState.STARTED);
            } else {
                dispatchLogInState(LoginState.IDLE);
                snackError("Invalid Email address provided");
            }
        } else {
            dispatchLogInState(LoginState.IDLE);
            snackError("Invalid credentials provided");
        }
    }

    const initSignUp = () => {
        setNavigateToSignUp(true);
    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
            {
                loggedIn && <Redirect to={Routes.HOME}/>
            }
            {
                navigateToSignUp && <Redirect to={Routes.SIGN_UP}/>
            }
            <form style={{
                display: 'flex',
                flexDirection: 'row',
            }}>
                <LoginEmailView/>
                <LoginPasswordView/>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row'
                }}>
                    <Button
                        style={{
                            color: 'white'
                        }}
                        onClick={initLogin}
                        disabled={loginStarted}
                        className={clsx(classes.desktopLogin, (logInEmail && loginPassword && !loginStarted && classes.desktopLoginFilled))}
                        variant={"outlined"}>
                        {loginStarted ? "" : Strings.LOGIN_TEXT}
                        {
                            loginStarted &&
                            <CircularProgress color="inherit" size={20} style={{
                                margin: 'auto',
                                color: 'white'
                            }}/>
                        }
                    </Button>
                    <Button disabled={loginStarted}
                            className={clsx(classes.authButton, classes.signUpButton)}
                            onClick={initSignUp}>{Strings.SIGNUP_TEXT}</Button>
                </div>
            </form>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'flex-start',
                marginTop: -10,
                justifyContent: 'space-between'
            }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={handleRememberMeChange}
                            value={rememberMe}
                            checked={rememberMe}
                            size={"small"}
                            checkedIcon={<span className={clsx(classes.orangeChecked)}/>}
                        />
                    }
                    label="Remember me"
                    classes={{
                        label: classes.rememberMeLabelStyle
                    }}
                />
                <Typography style={{
                    color: 'grey',
                    fontSize: 10,
                }}>
                    <Link to={loginState === LoginState.STARTED ? "#" : Routes.PASSWORD_RECOVERY}
                          style={{
                              color: `${AppColors.lightenOrDarken(AppColors.PRIMARY_COLOR, 80)}`,
                              fontWeight: 600,
                              textDecoration: 'none'
                          }}>
                        Forgot Password?
                    </Link>
                </Typography>
            </div>
            <MaterialSnackBar open={openSnack} onSnackClosed={handleSnackClose} message={snackMessage}
                              severity={snackSeverity}/>
        </div>
    );
}